module.exports = __webpack_public_path__ + "static/media/chih_chieh_chang.afcfe655.jpg";